import './App.css';
import GlobalStyle from './style/GlobalStyle';
import BioComponent from './main/BioPage';

function App() {
  return (
    <div>
      <GlobalStyle />
      <BioComponent />
    </div>
  );
}

export default App;
